import React, { useState } from "react";
import GeocodeLogger from "./GeocodeLogger";

const GeocodeFeedback: React.FC = () => {
 
  return (
    <div className="main-content">
       <div>
        <h1>Real-time Logger</h1>
        <GeocodeLogger />
      </div>
    </div>
  );
};

export default GeocodeFeedback; 